<template>
  <v-dialog scrollable max-width="800px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-btn color="info" small v-on="on" @click="cargar">Resumen</v-btn>
    </template>

    <v-card max-width="1030" class="mx-auto mt-5">
      <v-card-title> {{ descripcion }} </v-card-title>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Asignacion</th>
              <th class="text-right">Monto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="liq in liquidacionResumen" :key="liq.asignacion">
              <td class="text-left">{{ liq.asignacion }}</td>
              <td class="text-right">{{ liq.monto | numberFormat }}</td>
            </tr>
            <tr>
              <td class="text-left teal lighten-4">NETO</td>
              <td class="text-right teal lighten-4">
                {{ total | numberFormat }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="info" small @click="descargar()">Descargar Detalle</v-btn>
        <v-btn color="info" small @click="descargarResumen()"
          >Descargar Resumen</v-btn
        >
        <!-- <EnviarCorreo :id="this.liquidacion.id" v-if="this.liquidacion" /> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "axios";
import numeral from "numeral";
import { saveAs } from "file-saver";

export default {
  props: ["liquidacionId", "descripcion"],
  data() {
    return {
      showDialog: false,
      liquidacionResumen: [],
      errorMessage: "",
    };
  },
  methods: {
    cargar() {
      if (this.liquidacionId == null) {
        return;
      }

      axios
        .get("/autor/0/liquidacion/" + this.liquidacionId)
        .then((response) => {
          this.liquidacionResumen = response.data;
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = err.response.data;
        });
    },
    numberFormat(value) {
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
    descargar() {
      axios
        .get("/report/liquidacion/" + this.liquidacionId)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    descargarResumen() {
      axios
        .get("/report/liquidacionResumen/" + this.liquidacionId)
        .then((response) => {
          var blob = this.b64toBlob(
            response.data.fileContent,
            "application/pdf",
            null
          );
          saveAs(blob, response.data.fileName);
        })
        .catch((err) => {
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    volver() {
      this.showDialog = false;
    },
  },
  computed: {
    total() {
      return this.liquidacionResumen.reduce((a, b) => +a + b.monto, 0);
    },
  },
  filters: {
    numberFormat(value) {
      if (!value) {
        return numeral(0).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
      if (value) {
        return numeral(value).format("#,###"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  },
  components: {
      
  }
};
</script>